import { joinParams } from './joinParams'

const TWITTER_SHARE_BASE_URL = 'https://twitter.com/intent/tweet'
const FACEBOOK_SHARE_BASE_URL = 'https://www.facebook.com/sharer/sharer.php'
const LINE_SHARE_BASE_URL = 'https://social-plugins.line.me/lineit/share'

/**
 * Twitterシェア用のリンクをつくる
 * @param options.url シェアしたいURL
 * @param options.hashtags ハッシュタグ
 * @param options.text シェア文言
 * @return URL
 */
export const createTwitterShareUrl = (options: {
  url: string
  hashtags?: string | string[] | null
  text?: string
}) => {
  return `${TWITTER_SHARE_BASE_URL}?${joinParams({
    ...options,
    related: 'wear_official',
  }).toString()}`
}

/**
 * Facebookシェア用のリンクをつくる
 * @param options.url シェアしたいURL
 * @return URL
 */
export const createFacebookShareUrl = (options: { url: string }) => {
  return `${FACEBOOK_SHARE_BASE_URL}?${joinParams({
    u: options.url,
  }).toString()}`
}

/**
 * LINEシェア用のリンクをつくる
 * @param options.url シェアしたいURL
 * @return URL
 */
export const createLineShareUrl = (options: { url: string }) => {
  return `${LINE_SHARE_BASE_URL}?${joinParams({
    url: options.url,
  }).toString()}`
}
